import { styled } from '@mui/styles';
import { StatusWrapper } from '../../Applications/components/ApplicationStatus/styles';
import { colors } from '@mui/material';

export const ActiveStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: theme.palette.success.light,
  color: theme.palette.success.dark
}));

export const RequestedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: colors.orange[50],
  color: colors.orange[700]
}));

export const FrozenStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: colors.deepPurple[50],
  color: colors.deepPurple[500]
}));

export const SuspendedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: colors.red[50],
  color: colors.red[700]
}));

export const NotRequestedStatusWrapper = styled(StatusWrapper)(({ theme }) => ({
  background: colors.grey[200],
  color: colors.grey[500]
}));
